import React, { useRef } from 'react';

import classNames from 'classnames';

import { ReactComponent as ChevronIcon } from 'assets/icons/chevron-thin-left.svg';

import './SelectCyrcles.scss';

interface Props {
  options: any[];
  value: string;
  onChange: (value: any, option: any) => any;
  emptyItemLabel?: string;
  labelProperty?: string;
  idProperty?: string;
}

const SelectCyrcles: React.FC<Props> = ({
  value,
  options,
  onChange,
  labelProperty = 'label',
  idProperty = 'id',
}) => {
  const handleSelection = option => {
    onChange(option[idProperty], option);
  };

  const ref = useRef(null);

  const smoothScroll = (direction: 'backward' | 'forward') => {
    if (!ref.current) {
      return;
    }
    let scrollAmount = 0;
    const step = direction === 'forward' ? 2 : -2;
    const itemWidth = 56;
    const scrollItemCount = 3;

    const slideTimer = setInterval(() => {
      ref.current.scrollLeft += step;
      scrollAmount += Math.abs(step);
      if (scrollAmount >= itemWidth * scrollItemCount) {
        window.clearInterval(slideTimer);
      }
    }, 2);
  };

  return (
    <div className="selectCyrcles no-select">
      <div className="container" ref={ref}>
        <div className="prevBtn">
          <div className="item itemPrev" onClick={() => smoothScroll('backward')}>
            <ChevronIcon />
          </div>
        </div>
        <div className="items">
          {options.map(option => {
            return (
              <div
                onClick={() => handleSelection(option)}
                key={option[idProperty]}
                className={classNames('item', { itemSelected: option[idProperty] === value })}
              >
                {option[labelProperty]}
              </div>
            );
          })}
        </div>
        <div className="nextBtn">
          <div className="item itemNext rotate" onClick={() => smoothScroll('forward')}>
            <ChevronIcon />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SelectCyrcles;
